import { Injectable } from '@angular/core';
import { GeometricFormQuery } from '../../state/geometric-form.query';
import { GeometricFormType } from '../../state/geometric-form.type';
import { EdgeStore } from './edge.store';
import { Edge } from './edge.model';

@Injectable({ providedIn: 'root' })
export class EdgeQuery extends GeometricFormQuery<Edge> {

  type: GeometricFormType = 'mitra-edge';

  constructor(protected store: EdgeStore) {
    super(store);
  }

  exists(v1Id: number, v2Id: number) {
    return this.hasEntity(e =>
      e.vertex_a === v1Id && e.vertex_b === v2Id ||
      e.vertex_a === v2Id && e.vertex_b === v1Id
    );
  }

  findConnectedVertixesIds(vertexId: number): number[] {
    const edges = this.getAll({
      filterBy: e => e.vertex_a === vertexId || e.vertex_b === vertexId
    });

    const vertixesIds = edges.map(e => {
      return e.vertex_a === vertexId ? e.vertex_b : e.vertex_a;
    });
    return vertixesIds;
  }

}
